import LocationVisits from "./location-visits";


export default LocationVisits;